'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3, _class4, _class6, _class7, _class9, _dec, _class11, _class13, _dec2, _dec3, _class15, _class16, _temp6;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _reactDom = require('react-dom');

var _reactSortableHoc = require('react-sortable-hoc');

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _editorViewstore = require('./editor-viewstore');

var _editorViewstore2 = _interopRequireDefault(_editorViewstore);

var _simboxEditable = require('simbox-editable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlowActionBar = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(FlowActionBar, _BaseComponent);

  function FlowActionBar() {
    (0, _classCallCheck3.default)(this, FlowActionBar);
    return (0, _possibleConstructorReturn3.default)(this, (FlowActionBar.__proto__ || (0, _getPrototypeOf2.default)(FlowActionBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowActionBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$viewStore = this.props.viewStore,
          simulation = _props$viewStore.simulation,
          warnings = _props$viewStore.simulation.warnings,
          simulations = _props$viewStore.simulations,
          selectView = _props$viewStore.selectView,
          selectSimulation = _props$viewStore.selectSimulation,
          inEditNameMode = _props$viewStore.inEditNameMode,
          toggleEditNameMode = _props$viewStore.toggleEditNameMode,
          project = _props$viewStore.project;

      return _react2.default.createElement(
        'div',
        { className: 'action-bar' },
        _react2.default.createElement(
          'div',
          { className: 'actions-and-details' },
          _react2.default.createElement(
            'div',
            { className: 'sim-details' },
            _react2.default.createElement(
              'div',
              { className: this.props.viewStore.inEditNameMode === true ? 'detail display-name editing-text' : 'detail display-name' },
              _react2.default.createElement(
                'div',
                { onClick: function onClick() {
                    return toggleEditNameMode();
                  } },
                'Simulation',
                _react2.default.createElement('i', { className: 'fa fa-pencil-square-o', title: 'Edit Simulation Name' })
              ),
              _react2.default.createElement(
                'div',
                null,
                inEditNameMode ? _react2.default.createElement('input', { value: simulation.displayName, onChange: function onChange(e) {
                    return simulation.updateValue("displayName", e.target.value);
                  } }) : _react2.default.createElement(
                  'div',
                  { className: 'custom-select' },
                  _react2.default.createElement(
                    'select',
                    { value: simulation.id, onChange: function onChange(e) {
                        return selectSimulation(e.target.value);
                      } },
                    simulations.map(function (s) {
                      return _react2.default.createElement(
                        'option',
                        { key: s.id, value: s.id },
                        (s.displayName || s.id) + (s.anyDirty ? " **" : s.isPublishDirty ? " *" : "")
                      );
                    }),
                    _react2.default.createElement(
                      'option',
                      { value: '_new' },
                      'New Simulation...'
                    )
                  ),
                  _react2.default.createElement('div', null)
                )
              )
            ),
            !!simulation.shell && _react2.default.createElement(
              'div',
              { className: 'detail shell-name', 'data-editable': !simulation.shellType ? [simulation, "shellType"] : null },
              _react2.default.createElement(
                'span',
                null,
                'Shell Type',
                !!simulation.shell && _react2.default.createElement('i', { className: 'fa fa-pencil-square-o', onClick: function onClick() {
                    return selectView("edit" + simulation.shell.id);
                  } })
              ),
              _react2.default.createElement(
                'span',
                null,
                !!simulation.shellType && simulation.shellType.id
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sim-actions' },
            _react2.default.createElement(
              'div',
              { className: 'action activity-manager', onClick: function onClick(event) {
                  return _this2.props.viewStore.enableActivityManager();
                } },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Activity Manager'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { className: 'action view-simulation', onClick: function onClick() {
                  return warnings.length ? _this2.props.viewStore.handleViewSimWarnings(warnings) : selectView(simulation.id);
                } },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'View Simulation'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.props.viewStore.createNewRound();
                }, className: 'action new-round' },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'New Round'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.props.viewStore.handleDeleteAllRounds(event);
                }, className: 'action delete-all' },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Delete All Rounds'
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.anyDirty && _this2.props.viewStore.revertSimulation();
                }, className: "cancel action " + (simulation.anyDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Revert'
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.anyDirty && _this2.props.viewStore.saveSimulation();
                }, className: "save action " + (simulation.anyDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Save'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.publishWarnings.length ? alert(simulation.publishWarnings) : simulation.exportToServer();
                }, className: "publish action " + (!simulation.publishWarnings.length && simulation.isPublishDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Publish'
              )
            )
          )
        )
      );
    }
  }]);
  return FlowActionBar;
}(_baseComponent2.default)) || _class) || _class;

;

var FlowQuickNav = (0, _mobxReact.observer)(_class2 = function (_BaseComponent2) {
  (0, _inherits3.default)(FlowQuickNav, _BaseComponent2);

  function FlowQuickNav() {
    (0, _classCallCheck3.default)(this, FlowQuickNav);
    return (0, _possibleConstructorReturn3.default)(this, (FlowQuickNav.__proto__ || (0, _getPrototypeOf2.default)(FlowQuickNav)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowQuickNav, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'quick-navigation' },
        this.props.viewStore.simulation.rounds.map(function (round, roundIndex) {
          return _react2.default.createElement(
            'div',
            { key: roundIndex, className: 'item', onMouseEnter: function onMouseEnter(event) {
                return _this4.props.viewStore.selectActiveRoundQuickNav(event, roundIndex, 'enter');
              }, onMouseLeave: function onMouseLeave(event) {
                return _this4.props.viewStore.selectActiveRoundQuickNav(event, roundIndex, 'leave');
              }, title: round.displayName, onClick: function onClick(event) {
                return _this4.props.viewStore.quickNavToRound(event, roundIndex);
              } },
            _this4.props.viewStore.simulation.rounds.length < 25 ? _react2.default.createElement(
              'span',
              { className: 'title' },
              _this4.props.viewStore.simulation.rounds[roundIndex].displayName
            ) : ''
          );
        })
      );
    }
  }]);
  return FlowQuickNav;
}(_baseComponent2.default)) || _class2;

;

var FlowWorkspace = (0, _mobxReact.observer)(_class3 = function (_BaseComponent3) {
  (0, _inherits3.default)(FlowWorkspace, _BaseComponent3);

  function FlowWorkspace() {
    (0, _classCallCheck3.default)(this, FlowWorkspace);
    return (0, _possibleConstructorReturn3.default)(this, (FlowWorkspace.__proto__ || (0, _getPrototypeOf2.default)(FlowWorkspace)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowWorkspace, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableRoundsContainer, { viewStore: this.props.viewStore });
    }
  }]);
  return FlowWorkspace;
}(_baseComponent2.default)) || _class3;

;

var SortableRoundsContainer = (0, _mobxReact.observer)(_class4 = function (_BaseComponent4) {
  (0, _inherits3.default)(SortableRoundsContainer, _BaseComponent4);

  function SortableRoundsContainer() {
    var _ref;

    var _temp, _this6, _ret;

    (0, _classCallCheck3.default)(this, SortableRoundsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref = SortableRoundsContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableRoundsContainer)).call.apply(_ref, [this].concat(args))), _this6), _this6.onSortEnd = function () {
      var _this7;

      return (_this7 = _this6).__onSortEnd__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this6.axis = 'x', _this6.lockAxis = 'x', _this6.helperClass = 'dragging', _this6.pressDelay = 200, _this6.pressThreshold = 5, _temp), (0, _possibleConstructorReturn3.default)(_this6, _ret);
  }

  (0, _createClass3.default)(SortableRoundsContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref2) {
      var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.viewStore.simulation.rounds, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableRounds, {
        viewStore: this.props.viewStore,
        lockAxis: this.axis,
        axis: this.lockAxis,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressDelay: this.pressDelay,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableRoundsContainer;
}(_baseComponent2.default)) || _class4;

// const SortableRounds = SortableContainer(
//   observer(({ viewStore }) => {
//     return (
//       <div className="workspace-container">
//         <div className={viewStore.viewModeExpanded === true ? 'workspace' : 'workspace expanded-view'}>
//           {viewStore.simulation.rounds.map((round, roundIndex) => 
//             <SortableRound index={roundIndex} key={`round-${roundIndex}`} viewStore={viewStore} round={round} roundIndex={roundIndex}/>
//           )}
//         </div>
//       </div>
//     );
//   }));

var SortableRounds = (0, _reactSortableHoc.SortableContainer)(_class6 = (0, _mobxReact.observer)(_class6 = function (_BaseComponent5) {
  (0, _inherits3.default)(SortableRounds, _BaseComponent5);

  function SortableRounds() {
    (0, _classCallCheck3.default)(this, SortableRounds);
    return (0, _possibleConstructorReturn3.default)(this, (SortableRounds.__proto__ || (0, _getPrototypeOf2.default)(SortableRounds)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableRounds, [{
    key: 'render',
    value: function render() {
      var viewStore = this.props.viewStore;

      return _react2.default.createElement(
        'div',
        { className: 'workspace-container' },
        _react2.default.createElement(
          'div',
          { className: viewStore.viewModeExpanded === true ? 'workspace' : 'workspace expanded-view' },
          viewStore.simulation.rounds.map(function (round, roundIndex) {
            return _react2.default.createElement(SortableRound, { index: roundIndex, key: 'round-' + roundIndex, viewStore: viewStore, round: round, roundIndex: roundIndex });
          })
        )
      );
    }
  }]);
  return SortableRounds;
}(_baseComponent2.default)) || _class6) || _class6;

var SortableRound = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref3) {
  var viewStore = _ref3.viewStore,
      round = _ref3.round,
      roundIndex = _ref3.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'round-wrapper', onMouseEnter: function onMouseEnter(event) {
        return viewStore.selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, 'enter');
      }, onMouseLeave: function onMouseLeave(event) {
        return viewStore.selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, 'leave');
      } },
    _react2.default.createElement(
      'div',
      { className: 'round' },
      _react2.default.createElement(
        'div',
        { className: 'rounds-details' },
        _react2.default.createElement(
          'div',
          { className: 'detail display-name' },
          _react2.default.createElement('span', { className: 'action expand-collapse-round', title: viewStore.viewModeExpanded === true ? "Expand To Detailed View" : "", onClick: function onClick(event) {
              return viewStore.toggleViewMode(event, roundIndex);
            } }),
          _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
              return viewStore.updateRoundDisplayName(event, round);
            }, value: round.displayName }),
          _react2.default.createElement('span', { className: 'action delete-round', title: 'Delete Round', onClick: function onClick(event) {
              viewStore.handleDeleteRound(event, roundIndex);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail begin-time' },
          _react2.default.createElement(
            'span',
            null,
            'Begin Time:'
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
                return viewStore.updateRoundBeginTime(event, round);
              }, defaultValue: round.beginTime })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail begin-time' },
          _react2.default.createElement(
            'span',
            null,
            'End Time:'
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
                return viewStore.updateRoundEndTime(event, round);
              }, defaultValue: round.endTime })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail notes' },
          _react2.default.createElement(
            'div',
            null,
            'Notes: '
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('textarea', { rows: '4', cols: '50', onChange: function onChange(event) {
                return viewStore.updateRoundNotes(event, round);
              }, placeholder: 'Enter Notes Here...', defaultChecked: round.userNotes })
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'team-states-container' },
        _react2.default.createElement(SortableStatesContainer, { index: roundIndex, key: 'states-' + roundIndex, viewStore: viewStore, round: round, roundIndex: roundIndex })
      )
    )
  );
}));

var SortableStatesContainer = (0, _mobxReact.observer)(_class7 = function (_BaseComponent6) {
  (0, _inherits3.default)(SortableStatesContainer, _BaseComponent6);

  function SortableStatesContainer() {
    var _ref4;

    var _temp2, _this9, _ret2;

    (0, _classCallCheck3.default)(this, SortableStatesContainer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this9 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = SortableStatesContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableStatesContainer)).call.apply(_ref4, [this].concat(args))), _this9), _this9.onSortEnd = function () {
      var _this10;

      return (_this10 = _this9).__onSortEnd__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this9.axis = 'y', _this9.lockAxis = 'y', _this9.helperClass = 'dragging', _this9.pressDelay = 200, _this9.pressThreshold = 5, _temp2), (0, _possibleConstructorReturn3.default)(_this9, _ret2);
  }

  (0, _createClass3.default)(SortableStatesContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref5) {
      var oldIndex = _ref5.oldIndex,
          newIndex = _ref5.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.round.teamStates, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableStates, {
        viewStore: this.props.viewStore,
        round: this.props.round,
        roundIndex: this.props.roundIndex,
        lockAxis: this.lockAxis,
        axis: this.axis,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressDelay: this.pressDelay,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableStatesContainer;
}(_baseComponent2.default)) || _class7;

var SortableStates = (0, _reactSortableHoc.SortableContainer)((0, _mobxReact.observer)(function (_ref6) {
  var viewStore = _ref6.viewStore,
      round = _ref6.round,
      roundIndex = _ref6.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'team-states' },
    round.teamStates.map(function (state, stateIndex) {
      return _react2.default.createElement(SortableState, { index: stateIndex, key: 'state-' + stateIndex, viewStore: viewStore, round: round, state: state, stateIndex: stateIndex, roundIndex: roundIndex });
    }),
    _react2.default.createElement(
      'div',
      { className: 'add-team-state-container' },
      _react2.default.createElement(
        'div',
        { className: 'add-team-state', onClick: function onClick(event) {
            return viewStore.addNewTeamState(event, round, roundIndex);
          } },
        'New State'
      )
    )
  );
}));

var SortableState = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref7) {
  var viewStore = _ref7.viewStore,
      round = _ref7.round,
      state = _ref7.state,
      stateIndex = _ref7.stateIndex,
      roundIndex = _ref7.roundIndex;

  var tsState = viewStore.teamStatesState.get(state.id);
  if (!tsState) return false;
  return _react2.default.createElement(
    'div',
    { className: tsState && tsState.collapsed === true ? 'team-state collapsed' : 'team-state', key: stateIndex },
    _react2.default.createElement(
      'div',
      { className: 'detail display-name' },
      _react2.default.createElement('span', { className: 'carrot', onClick: function onClick(event) {
          return viewStore.toggleTeamStateCollapse(event, state);
        }, title: tsState && tsState.collapsed === true ? 'Open State' : 'Close State' }),
      _react2.default.createElement(
        'span',
        { className: tsState.collapsed === false ? 'task-count-indicator hidden' : 'task-count-indicator' },
        state.tasks.length
      ),
      _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
          return viewStore.updateTeamStateDisplayName(event, state);
        }, value: state.displayName }),
      _react2.default.createElement(
        'div',
        { className: 'state-actions' },
        _react2.default.createElement('span', { className: 'action delete', title: 'Delete State', onClick: function onClick(event) {
            viewStore.handleDeleteState(event, round, stateIndex);
          } })
      )
    ),
    _react2.default.createElement(SortableTasksContainer, { viewStore: viewStore, key: 'tasks-' + stateIndex, round: round, state: state, stateIndex: stateIndex, roundIndex: roundIndex, index: stateIndex })
  );
}));

var SortableTasksContainer = (0, _mobxReact.observer)(_class9 = function (_BaseComponent7) {
  (0, _inherits3.default)(SortableTasksContainer, _BaseComponent7);

  function SortableTasksContainer() {
    var _ref8;

    var _temp3, _this11, _ret3;

    (0, _classCallCheck3.default)(this, SortableTasksContainer);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this11 = (0, _possibleConstructorReturn3.default)(this, (_ref8 = SortableTasksContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableTasksContainer)).call.apply(_ref8, [this].concat(args))), _this11), _this11.onSortEnd = function () {
      var _this12;

      return (_this12 = _this11).__onSortEnd__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this11.axis = 'y', _this11.lockAxis = 'y', _this11.helperClass = 'dragging', _this11.pressDelay = 200, _this11.pressThreshold = 5, _temp3), (0, _possibleConstructorReturn3.default)(_this11, _ret3);
  }

  (0, _createClass3.default)(SortableTasksContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref9) {
      var oldIndex = _ref9.oldIndex,
          newIndex = _ref9.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.state.tasks, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableTasks, {
        viewStore: this.props.viewStore,
        round: this.props.round,
        state: this.props.state,
        roundIndex: this.props.roundIndex,
        stateIndex: this.props.stateIndex,
        axis: this.axis,
        lockAxis: this.lockAxis,
        pressDelay: this.pressDelay,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableTasksContainer;
}(_baseComponent2.default)) || _class9;

var SortableTasks = (0, _reactSortableHoc.SortableContainer)((0, _mobxReact.observer)(function (_ref10) {
  var viewStore = _ref10.viewStore,
      state = _ref10.state,
      round = _ref10.round,
      stateIndex = _ref10.stateIndex,
      roundIndex = _ref10.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'tasks' },
    viewStore.viewModeExpanded === false && state.tasks.length !== 0 ? _react2.default.createElement(
      'div',
      { className: 'task task-category-labels' },
      _react2.default.createElement(
        'div',
        { className: 'task-details' },
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'ID'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Type'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Title'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Description'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'task-actions-container' },
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Actions'
        )
      )
    ) : '',
    state.tasks.map(function (task, taskIndex) {
      return _react2.default.createElement(SortableTask, { viewStore: viewStore, key: 'task-' + taskIndex, index: taskIndex, taskIndex: taskIndex, task: task, state: state, round: round });
    }),
    state.tasks.length === 0 && _react2.default.createElement(
      'div',
      { className: 'state-empty' },
      'State Empty'
    ),
    _react2.default.createElement(
      'div',
      { className: 'add-task-container' },
      _react2.default.createElement(
        'div',
        { className: 'add-task', onClick: function onClick(event) {
            return viewStore.addTaskToSelectedState(event, state, round, stateIndex, roundIndex);
          } },
        'Add Activity'
      )
    )
  );
}));

var SortableTask = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref11) {
  var viewStore = _ref11.viewStore,
      taskIndex = _ref11.taskIndex,
      task = _ref11.task,
      state = _ref11.state,
      round = _ref11.round;
  return _react2.default.createElement(
    'div',
    { className: 'task' },
    _react2.default.createElement(
      'div',
      { className: 'task-details' },
      viewStore.viewModeExpanded === false ? _react2.default.createElement(
        'div',
        { className: 'detail id' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'ID: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          viewStore.tasks[task.id]["id"]
        )
      ) : '',
      _react2.default.createElement(
        'div',
        { className: 'detail display-title' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Title: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          task.displayTitle
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'detail activity-type' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Type: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          task.activityType.id
        )
      ),
      viewStore.viewModeExpanded === false ? _react2.default.createElement(
        'div',
        { className: 'detail description' },
        _react2.default.createElement('span', null),
        _react2.default.createElement(
          'span',
          null,
          task.description
        )
      ) : '',
      _react2.default.createElement(
        'div',
        { className: 'detail required' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Required: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('input', { type: 'checkbox', className: 'toggle', onChange: function onChange(event) {
              return viewStore.updateTaskRequired(event, task);
            }, checked: task.required }),
          _react2.default.createElement(
            'label',
            { onClick: function onClick(event) {
                return viewStore.updateTaskRequired(event, task);
              } },
            _react2.default.createElement('span', null)
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'task-actions-container' },
      _react2.default.createElement(
        'div',
        { className: 'task-actions' },
        _react2.default.createElement(
          'div',
          { className: 'action delete', onClick: function onClick(event) {
              return viewStore.deleteTaskFromTeamState(event, state, taskIndex);
            } },
          'Remove'
        ),
        _react2.default.createElement(
          'div',
          { className: 'action view', onClick: function onClick(event) {
              return viewStore.viewTaskPreview(event, state, round, task);
            } },
          'View'
        )
      )
    )
  );
}));

var TaskManager = (_dec = (0, _mobxReact.inject)('editorViewStore'), _dec(_class11 = (0, _mobxReact.observer)(_class11 = function (_BaseComponent8) {
  (0, _inherits3.default)(TaskManager, _BaseComponent8);

  function TaskManager() {
    var _ref12;

    var _temp4, _this13, _ret4;

    (0, _classCallCheck3.default)(this, TaskManager);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this13 = (0, _possibleConstructorReturn3.default)(this, (_ref12 = TaskManager.__proto__ || (0, _getPrototypeOf2.default)(TaskManager)).call.apply(_ref12, [this].concat(args))), _this13), _this13.taskTypePlaceholder = 'Select Task Type...', _temp4), (0, _possibleConstructorReturn3.default)(_this13, _ret4);
  }

  (0, _createClass3.default)(TaskManager, [{
    key: 'generateTask',
    value: function generateTask(taskKey) {
      var _this14 = this;

      var task = this.props.viewStore.tasks[taskKey];
      if (this.props.viewStore.tasks[taskKey].displayTitle.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1 || this.props.viewStore.tasks[taskKey].description.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1 || this.props.viewStore.tasks[taskKey].activityType.id && this.props.viewStore.tasks[taskKey].activityType.id.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1) {
        var _React$createElement;

        return _react2.default.createElement(
          'div',
          (_React$createElement = { className: 'task' }, (0, _defineProperty3.default)(_React$createElement, 'className', this.props.viewStore.taskPickerActiveTask === taskKey ? "task viewing" : "task"), (0, _defineProperty3.default)(_React$createElement, 'key', taskKey), (0, _defineProperty3.default)(_React$createElement, 'onClick', function onClick(event) {
            return _this14.props.viewStore.viewTaskInTaskPicker(taskKey);
          }), _React$createElement),
          this.props.viewStore.activityManagerActive !== true && _react2.default.createElement(
            'div',
            { className: 'add-to-que' },
            _react2.default.createElement(
              'span',
              { className: 'checkbox-item' },
              _react2.default.createElement('input', { type: 'checkbox', className: 'checkbox green', checked: this.props.viewStore.taskPickerQue.indexOf(taskKey) > -1 ? 'checked' : '' }),
              _react2.default.createElement(
                'label',
                { onClick: function onClick(event) {
                    return _this14.props.viewStore.addTaskToQue(taskKey);
                  } },
                _react2.default.createElement('span', null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'details' },
            _react2.default.createElement(
              'div',
              { className: 'detail', title: 'ID: ' + this.props.viewStore.tasks[taskKey].id },
              this.props.viewStore.tasks[taskKey].displayTitle
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail' },
              this.props.viewStore.tasks[taskKey].activityType.id
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail' },
              this.props.viewStore.tasks[taskKey].description
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              { className: 'clone action', onClick: function onClick(e) {
                  return _this14.props.viewStore.cloneTask(task);
                } },
              'Clone'
            ),
            _react2.default.createElement(
              'div',
              { className: 'delete action', onClick: function onClick(e) {
                  return _this14.props.viewStore.permanentlyDeleteTask(task);
                } },
              'Delete'
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this15 = this;

      var self = this;
      var _props = this.props,
          _props$viewStore2 = _props.viewStore,
          componentList = _props$viewStore2.componentList,
          SelectedView = _props$viewStore2.SelectedView,
          selectedTask = _props$viewStore2.selectedTask,
          editorViewStore = _props.editorViewStore;


      function titleCase(str) {
        if (str != undefined) {
          var splitStr = str.replace('-', ' ').toLowerCase().split(' ');
          for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
          }
          return splitStr.join(' ');
        } else {
          return str;
        }
      }

      return _react2.default.createElement(
        'div',
        { className: "task-picker " + (this.props.active === true ? 'active' : '') },
        _react2.default.createElement(
          'div',
          (0, _defineProperty3.default)({ className: 'task-pool' }, 'className', this.props.viewStore.taskPickerViewOnlyMode === false ? 'task-pool' : 'task-pool view-only-mode'),
          _react2.default.createElement(
            'div',
            { className: 'header' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Activity Manager'
            ),
            _react2.default.createElement(
              'div',
              { className: 'round-and-state-details' },
              _react2.default.createElement(
                'div',
                { className: 'details' },
                _react2.default.createElement(
                  'div',
                  { className: 'round-name' },
                  _react2.default.createElement(
                    'span',
                    { className: 'icon' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Target Round - '
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    this.props.viewStore.taskPickerRoundObj && this.props.viewStore.taskPickerRoundObj.displayName
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'state-name' },
                  _react2.default.createElement(
                    'span',
                    { className: 'icon' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Target State - '
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              (0, _defineProperty3.default)({ className: 'filter search' }, 'className', this.props.viewStore.taskPickerNewTaskBuilderActive === true ? 'filter search expand-input' : 'filter search'),
              _react2.default.createElement('input', { type: 'text', placeholder: 'Activity Search...', value: this.props.viewStore.taskPickerSearchFilter, onChange: function onChange(event) {
                  return _this15.props.viewStore.updateTaskPickerSearchFilter(event);
                } }),
              this.props.viewStore.taskPickerNewTaskBuilderActive === false ? _react2.default.createElement(
                'div',
                { className: this.props.viewStore.taskPickerViewOnlyMode === true ? 'btn green add-a' : 'btn green add-a', onClick: function onClick(event) {
                    return _this15.props.viewStore.createNewTask();
                  } },
                'Create Activity'
              ) : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: this.props.viewStore.activityManagerActive !== true ? 'pool' : 'pool task-manager-active' },
            (0, _keys2.default)(self.props.viewStore.tasks).map(function (task, taskIndex, tasks) {
              return self.generateTask(task);
            })
          ),
          this.props.viewStore.activityManagerActive !== true && _react2.default.createElement(
            'div',
            { className: 'footer' },
            _react2.default.createElement(
              'div',
              { className: 'round-name' },
              _react2.default.createElement(
                'span',
                { className: 'icon' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Target Round - '
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                this.props.viewStore.taskPickerRoundObj && this.props.viewStore.taskPickerRoundObj.displayName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'state-name' },
              _react2.default.createElement(
                'span',
                { className: 'icon' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Target State - '
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: this.props.viewStore.taskPickerQue.length ? "btn green checked-b" : "btn green checked-b disabled", onClick: function onClick(event) {
                  return self.props.viewStore.addSelectedTasksToState();
                } },
              'Add Checked To: ',
              _react2.default.createElement(
                'b',
                null,
                this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.viewStore.taskPickerViewOnlyMode === false ? 'task-viewer' : 'task-viewer view-only-mode' },
          _react2.default.createElement(
            'div',
            { className: 'title-bar' },
            _react2.default.createElement(
              'span',
              { className: 'detail' },
              this.props.viewStore.taskPickerActiveTask !== null ? selectedTask.displayTitle : '',
              ' '
            ),
            this.props.viewStore.taskPickerActiveTask !== null && _react2.default.createElement(
              'div',
              { className: this.props.editorViewStore.isEditorOpen === false ? 'btn-b edit-b' : 'btn-b edit-b hide', onClick: function onClick() {
                  return editorViewStore.startEditing(selectedTask.activity);
                } },
              'Edit'
            ),
            _react2.default.createElement(
              'div',
              { className: this.props.editorViewStore.isEditorOpen === false ? 'btn-b arrow-left-b' : 'btn-b arrow-left-b hide', onClick: function onClick(event) {
                  return _this15.props.viewStore.closeTaskPicker();
                } },
              'Back'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'viewport' },
            this.props.viewStore.taskPickerNewTaskBuilderActive !== false ? _react2.default.createElement(
              'div',
              { className: 'task-creator' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Create Activity'
              ),
              _react2.default.createElement(
                'div',
                { className: 'options' },
                _react2.default.createElement(
                  'div',
                  { className: 'detail select-component' },
                  _react2.default.createElement(
                    'div',
                    { className: 'custom-select' },
                    _react2.default.createElement(
                      'select',
                      { onChange: function onChange(event) {
                          return _this15.props.viewStore.updateNewTaskType(event);
                        } },
                      _react2.default.createElement(
                        'option',
                        { selected: true, disabled: true },
                        'Activity Type...'
                      ),
                      componentList.map(function (type, tIndex) {
                        return _react2.default.createElement(
                          'option',
                          { key: tIndex, value: componentList[tIndex] },
                          componentList[tIndex]
                        );
                      })
                    ),
                    _react2.default.createElement('div', null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail display-name' },
                  _react2.default.createElement('input', { placeholder: 'Activity Name', type: 'text', onChange: function onChange(event) {
                      return _this15.props.viewStore.updateNewTaskDisplayTitle(event);
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail description' },
                  _react2.default.createElement('textarea', { placeholder: 'Activity Description (optional)', type: 'text', onChange: function onChange(event) {
                      return _this15.props.viewStore.updateNewTaskDescription(event);
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'validation' },
                  this.props.viewStore.taskPickerNewTaskType === '' || this.props.viewStore.taskPickerNewTaskType === this.taskTypePlaceholder ? _react2.default.createElement(
                    'div',
                    { className: 'item' },
                    'You must select an activity type'
                  ) : "",
                  this.props.viewStore.taskPickerNewTaskTitle === '' ? _react2.default.createElement(
                    'div',
                    { className: 'item' },
                    'You must give the new activity a name'
                  ) : ""
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'actions' },
                  _react2.default.createElement(
                    'span',
                    { className: 'btn red cancel-b', onClick: function onClick(event) {
                        return _this15.props.viewStore.cancelTaskCreation();
                      } },
                    'Cancel'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: this.props.viewStore.taskPickerNewTaskTitle !== '' && this.props.viewStore.taskPickerNewTaskType !== this.taskTypePlaceholder && this.props.viewStore.taskPickerNewTaskType !== '' ? 'btn green add-a' : 'btn green add-a disabled', onClick: function onClick(event) {
                        return _this15.props.viewStore.createSelectedTask();
                      } },
                    'Create'
                  )
                )
              )
            ) : '',
            !!SelectedView && this.props.viewStore.taskPickerActiveTask !== null && this.props.viewStore.taskPickerNewTaskBuilderActive === false ? _react2.default.createElement(
              'div',
              { className: 'task-preview' },
              _react2.default.createElement(SelectedView, null)
            ) : '',
            this.props.viewStore.taskPickerActiveTask !== null || this.props.viewStore.taskPickerNewTaskBuilderActive === true ? '' : _react2.default.createElement(
              'div',
              { className: 'select-task-message' },
              'Select An Activity...'
            )
          )
        )
      );
    }
  }]);
  return TaskManager;
}(_baseComponent2.default)) || _class11) || _class11);

var NothingToShowMessage = (0, _mobxReact.observer)(_class13 = function (_BaseComponent9) {
  (0, _inherits3.default)(NothingToShowMessage, _BaseComponent9);

  function NothingToShowMessage() {
    var _ref13;

    var _temp5, _this16, _ret5;

    (0, _classCallCheck3.default)(this, NothingToShowMessage);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret5 = (_temp5 = (_this16 = (0, _possibleConstructorReturn3.default)(this, (_ref13 = NothingToShowMessage.__proto__ || (0, _getPrototypeOf2.default)(NothingToShowMessage)).call.apply(_ref13, [this].concat(args))), _this16), _this16.quotes = [{
      "quote": "The creation of a thousand forests is in one acorn",
      "author": "Ralph Waldo Emerson"
    }, {
      "quote": "Innovation has nothing to do with how many R & D dollars you have. When Apple came up with the Mac, IBM was spending at least 100 times more on R & D. It's not about money. It's about the people you have, how you're led, and how much you get it.",
      "author": "Steve Jobs"
    }, {
      "quote": "The main factor in any form of creativeness is the life of a human spirit, that of the actor and his part, their joint feelings and subconscious creation.",
      "author": "Constantin Stanislavski"
    }, {
      "quote": "Let the future tell the truth, and evaluate each one according to his work and accomplishments. The present is theirs; the future, for which I have really worked, is mine.",
      "author": "Nikola Tesla"
    }, {
      "quote": "Genius is one percent inspiration and ninety-nine percent perspiration.",
      "author": "Thomas A. Edison"
    }, {
      "quote": "I'm an inventor. I became interested in long-term trends because an invention has to make sense in the world in which it is finished, not the world in which it is started.",
      "author": "Ray Kurzweil"
    }, {
      "quote": "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma - which is living with the results of other people's thinking. Don't let the noise of others' opinions drown out your own inner voice. And most important, have the courage to follow your heart and intuition.",
      "author": "Steve Jobs"
    }, {
      "quote": "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work. And the only way to do great work is to love what you do. If you haven't found it yet, keep looking. Don't settle. As with all matters of the heart, you'll know when you find it.",
      "author": "Steve Jobs"
    }], _this16.newQuote = _this16.generateQuote(), _temp5), (0, _possibleConstructorReturn3.default)(_this16, _ret5);
  }

  (0, _createClass3.default)(NothingToShowMessage, [{
    key: 'generateQuote',
    value: function generateQuote() {
      var randomQuote = Math.floor(Math.random() * this.quotes.length);
      return _react2.default.createElement(
        'div',
        { className: 'quote' },
        _react2.default.createElement(
          'div',
          { className: 'text' },
          _react2.default.createElement(
            'b',
            null,
            '"'
          ),
          this.quotes[randomQuote]["quote"],
          _react2.default.createElement(
            'b',
            null,
            '"'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'author' },
          '~ ',
          this.quotes[randomQuote]["author"]
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this;

      var options = this.props.viewStore.simulation.$parent.entities.get("RegisteredShellContentModel").entities.map(function (ent) {
        return ent.id;
      });
      return _react2.default.createElement(
        'div',
        { className: 'workspace-container empty' },
        _react2.default.createElement(
          'div',
          { className: 'workspace' },
          _react2.default.createElement(
            'div',
            { className: 'empty-message' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Let\'s Build Something Awesome!'
            ),
            this.newQuote,
            _react2.default.createElement(
              'div',
              { className: 'display-name' },
              _react2.default.createElement('input', { placeholder: 'Enter Simulation Name', onChange: function onChange(e) {
                  return _this17.props.viewStore.simulation.updateValue("displayName", e.target.value);
                } })
            ),
            !this.props.viewStore.simulation.shellType && _react2.default.createElement(
              'div',
              { className: 'custom-select' },
              _react2.default.createElement(
                'select',
                { onChange: function onChange(e) {
                    return _this17.props.viewStore.simulation.updateValue("shellType", e.target.value);
                  } },
                _react2.default.createElement(
                  'option',
                  null,
                  'Select Simulation Shell'
                ),
                options.map(function (o) {
                  return _react2.default.createElement(
                    'option',
                    { key: o },
                    o
                  );
                })
              ),
              _react2.default.createElement('div', null)
            ),
            _react2.default.createElement(
              'div',
              { className: !this.props.viewStore.simulation.shellType ? 'flow-button create-new-round disabled' : 'flow-button create-new-round', onClick: function onClick() {
                  return _this17.props.viewStore.createNewRound();
                } },
              'Create Simulation'
            )
          )
        )
      );
    }
  }]);
  return NothingToShowMessage;
}(_baseComponent2.default)) || _class13;

var LinearFlowEditor = (_dec2 = (0, _mobxReact.inject)('editorViewStore'), _dec3 = (0, _mobxReact.inject)('modalViewStore'), _dec2(_class15 = _dec3(_class15 = (0, _mobxReact.observer)(_class15 = (_temp6 = _class16 = function (_BaseComponent10) {
  (0, _inherits3.default)(LinearFlowEditor, _BaseComponent10);

  function LinearFlowEditor() {
    (0, _classCallCheck3.default)(this, LinearFlowEditor);
    return (0, _possibleConstructorReturn3.default)(this, (LinearFlowEditor.__proto__ || (0, _getPrototypeOf2.default)(LinearFlowEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinearFlowEditor, [{
    key: 'render',
    value: function render() {
      var _this19 = this;

      var _viewStore = this.viewStore,
          currentView = _viewStore.currentView,
          clearView = _viewStore.clearView,
          SelectedView = _viewStore.SelectedView;


      if (currentView && currentView.id.indexOf("simulation_") === 0) {
        // When viewing simulation player
        return _react2.default.createElement(
          'div',
          { className: 'shell-wrapper ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'header-bar-closed' : 'header-bar-open') },
          _react2.default.createElement(
            'div',
            { className: 'sim-shell-actions ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'closed' : 'opened') },
            _react2.default.createElement(
              'div',
              { className: 'shell-viewer-title' },
              'Simulation Preview'
            ),
            _react2.default.createElement(
              'div',
              { className: 'btn-b arrow-left-b', onClick: function onClick() {
                  return clearView();
                } },
              'Back'
            ),
            _react2.default.createElement('div', { className: 'toggle ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'closed' : 'opened'), onClick: function onClick() {
                return _this19.viewStore.toggleSimPreviewActions();
              } })
          ),
          _react2.default.createElement(SelectedView, { className: 'activity' })
        );
      } else if (currentView && currentView.id.indexOf("editsimulation_") === 0) {
        // When viewing shell edit view
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sim-shell-options' },
            _react2.default.createElement(
              'div',
              { className: '', onClick: function onClick() {
                  return clearView();
                } },
              'Back'
            )
          ),
          _react2.default.createElement(SelectedView, null)
        );
      } else {
        // When viewing linear flow editor
        return _react2.default.createElement(
          'div',
          { className: 'flow-and-tasks' },
          _react2.default.createElement(
            'div',
            { className: "flow-editor " + (this.viewStore.taskPickerActive === false ? "active" : "") },
            _react2.default.createElement(FlowActionBar, { viewStore: this.viewStore }),
            _react2.default.createElement(FlowQuickNav, { viewStore: this.viewStore }),
            this.viewStore.simulation.rounds.length !== 0 ? _react2.default.createElement(FlowWorkspace, { viewStore: this.viewStore }) : _react2.default.createElement(NothingToShowMessage, { viewStore: this.viewStore })
          ),
          _react2.default.createElement(TaskManager, { viewStore: this.viewStore, active: this.viewStore.taskPickerActive === true })
        );
      }
    }
  }]);
  return LinearFlowEditor;
}(_baseComponent2.default), _class16.ViewStore = _editorViewstore2.default, _temp6)) || _class15) || _class15) || _class15);
;

var _default = LinearFlowEditor;
exports.default = _default;
;

var _temp7 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FlowActionBar, 'FlowActionBar', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(FlowQuickNav, 'FlowQuickNav', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(FlowWorkspace, 'FlowWorkspace', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRoundsContainer, 'SortableRoundsContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRounds, 'SortableRounds', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRound, 'SortableRound', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableStatesContainer, 'SortableStatesContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableStates, 'SortableStates', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableState, 'SortableState', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTasksContainer, 'SortableTasksContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTasks, 'SortableTasks', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTask, 'SortableTask', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(TaskManager, 'TaskManager', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(NothingToShowMessage, 'NothingToShowMessage', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(LinearFlowEditor, 'LinearFlowEditor', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/project-entity/editor.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/project-entity/editor.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor.js
// module chunks = 0